module.exports = __webpack_public_path__ + "media/images/help_correction_3-440520b6a1f2fa98c4cf3abcaad4b872.png";